/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-26 12:54:34
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/AutoPlay/index.tsx
 */
/**
 *  Autoplay Component
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';
import css from './css.less';

import { Checkbox, NumberInput } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const AutoPlay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { autoOnChange, isAuto, interval, interOnChange, disabled } = props;
  const handleOnBlur = () => {
    if (!!!interval) {
      interOnChange(3);
    }
  };
  const handleOnChange = (e) => {
    if (interOnChange && e) {
      interOnChange(e);
    }
  };
  return (
    <div className={css.container}>
      <Checkbox
        checked={isAuto}
        disabled={disabled}
        onChange={(e, E) => {
          if (autoOnChange) autoOnChange(e, E);
        }}>
        {getI18n('general.autoplay')}
      </Checkbox>
      <div className={css.tip}>{getI18n('general.intervaltime')}</div>
      <div className={css.numberInputContainer}>
        <NumberInput
          className={css.numberInput}
          value={interval}
          onChange={handleOnChange}
          disabled={!isAuto || disabled}
          suffix={getI18n('general.seconds')}
          size='large'
          min={1}
          onBlur={handleOnBlur}
        />
      </div>
    </div>
  );
};
export default AutoPlay;
